import { createSelector } from 'reselect';
import { playerStatsSelector } from './simple-selectors';

export const playerStatsTemporaryFieldsSelector = createSelector(
    playerStatsSelector,
    (playerStats) => playerStats.temporaryFields
);
